import { getApiBaseUrl } from "../utils/getApiBaseUrl";
import { authHeaders } from "./authApi";

const API_BASE = getApiBaseUrl();
const PREFIX = `${API_BASE.replace(/\/$/, "")}/api/marketplace`;

async function parseJson(res) {
  try {
    return await res.json();
  } catch {
    return {};
  }
}

export async function getMarketplaceStores() {
  const res = await fetch(`${PREFIX}/stores`);
  const body = await parseJson(res);
  if (!res.ok) throw new Error(body.message || "Unable to load marketplace.");
  return body.data?.stores ?? [];
}

export async function getMarketplaceStoreBySlug(storeSlug) {
  const res = await fetch(`${PREFIX}/stores/${encodeURIComponent(storeSlug)}`, {
    headers: { ...authHeaders() },
  });
  const body = await parseJson(res);
  if (!res.ok) throw new Error(body.message || "Store not found.");
  return body.data ?? {};
}

export async function getMarketplaceStoreProducts(storeSlug) {
  const res = await fetch(`${PREFIX}/stores/${encodeURIComponent(storeSlug)}/products`);
  const body = await parseJson(res);
  if (!res.ok) throw new Error(body.message || "Unable to load store products.");
  return body.data?.products ?? [];
}

export async function getMarketplaceProducts(params = {}) {
  const u = new URLSearchParams();
  if (params.category) u.set("category", params.category);
  if (params.featured) u.set("featured", "true");
  const q = u.toString() ? `?${u.toString()}` : "";
  const res = await fetch(`${PREFIX}/products${q}`);
  const body = await parseJson(res);
  if (!res.ok) throw new Error(body.message || "Unable to load products.");
  return body.data?.products ?? [];
}

export async function getMarketplaceProductBySlug(productSlug, storeSlug = "") {
  const q = storeSlug ? `?storeSlug=${encodeURIComponent(storeSlug)}` : "";
  const res = await fetch(`${PREFIX}/products/${encodeURIComponent(productSlug)}${q}`, {
    headers: { ...authHeaders() },
  });
  const body = await parseJson(res);
  if (!res.ok) throw new Error(body.message || "Product not found.");
  return body.data ?? {};
}

/**
 * Authenticated card checkout — returns { url, orderId } on success.
 * @param {string} productId Mongo id of MarketplaceProduct
 * @param {{ quantity?: number }} [opts]
 */
export async function postMarketplaceCardCheckout(productId, opts = {}) {
  const res = await fetch(`${PREFIX}/products/${encodeURIComponent(productId)}/checkout/card`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: JSON.stringify({ quantity: opts.quantity ?? 1 }),
  });
  const body = await parseJson(res);
  if (res.status === 401 || res.status === 403) {
    const err = new Error(body.message || "Please log in to purchase.");
    err.code = "AUTH";
    throw err;
  }
  if (!res.ok) {
    const err = new Error(body.message || "Checkout unavailable.");
    err.code = body.code;
    throw err;
  }
  return body.data || {};
}
